import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n'
import App from './App.jsx'
import LoadingScreen from './components/LoadingScreen.jsx'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Suspense fallback={<LoadingScreen />}>
      <App />
    </Suspense>
  </StrictMode>,
)

// Initialise Google Analytics AFTER first paint so it never sits on the LCP
// critical path. Uses requestIdleCallback when available (Chrome / Firefox)
// and falls back to a setTimeout for Safari.
if (typeof window !== 'undefined') {
  const initAnalytics = () => {
    import('./firebase').then((m) => m.getAnalyticsLazy?.()).catch(() => {});
  };
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(initAnalytics, { timeout: 4000 });
  } else {
    setTimeout(initAnalytics, 2500);
  }
}
